import React, { useCallback, useEffect, useState } from 'react'
import { InputNumber, Popover } from 'antd'

export interface PenalizaciaValue {
	penaltyAmount?: number | null
}

interface Props {
	value?: PenalizaciaValue
	onChange?: (v: PenalizaciaValue) => void
	autoOpen?: boolean
	onDismiss?: () => void
	onRemove?: () => void
}

const PenalizaciaPopover = ({
	value,
	onChange,
	autoOpen,
	onDismiss,
	onRemove
}: Props) => {
	const [open, setOpen] = useState(() => autoOpen ?? false)
	const [draft, setDraft] = useState<PenalizaciaValue>(() => value ?? {})

	useEffect(() => {
		if (value !== undefined) {
			setDraft(value)
		}
	}, [value])

	const handleSave = useCallback(() => {
		onChange?.(draft)
		setOpen(false)
	}, [draft, onChange])

	const handleRemove = useCallback(() => {
		onRemove?.()
		setOpen(false)
	}, [onRemove])

	const handleVisibleChange = (next: boolean) => {
		setOpen(next)
		if (!next && !value?.penaltyAmount) {
			onDismiss?.()
		}
	}

	const hasCommittedValue = Boolean(value?.penaltyAmount)

	const triggerText = value?.penaltyAmount ? `${value.penaltyAmount} €` : null

	const triggerBorder = triggerText ? '1px solid #d1d5db' : '1px dashed #d1d5db'
	const triggerColor = triggerText ? '#374151' : '#9ca3af'

	const content = (
		<div style={{ padding: 16, width: 260 }}>
			<div style={{
				marginBottom: 12,
				fontWeight: 600,
				fontSize: 13,
				color: '#374151'
			}}>
				Penalizácia pri meškaní
			</div>
			<div style={{ marginBottom: 16 }}>
				<div style={{
					fontSize: 12,
					color: '#6b7280',
					marginBottom: 4
				}}>
					Penále
				</div>
				<InputNumber
					min={0}
					value={draft.penaltyAmount ?? undefined}
					onChange={(v) => setDraft((prev) => ({
						...prev,
						penaltyAmount: v ?? null
					}))}
					style={{ width: '100%' }}
					placeholder={'Napr. 10'}
					addonAfter={'€'}
				/>
			</div>
			<div style={{
				display: 'flex',
				gap: 8,
				justifyContent: 'space-between'
			}}>
				{hasCommittedValue && (
					<button
						type={'button'}
						onClick={handleRemove}
						style={{
							background: 'none',
							border: 'none',
							cursor: 'pointer',
							color: '#ef4444',
							fontSize: 13,
							padding: '4px 0'
						}}
					>
						Odstrániť
					</button>
				)}
				<button
					type={'button'}
					onClick={handleSave}
					style={{
						marginLeft: 'auto',
						background: '#1d4ed8',
						color: '#fff',
						border: 'none',
						borderRadius: 6,
						padding: '6px 16px',
						fontSize: 13,
						cursor: 'pointer',
						fontWeight: 600
					}}
				>
					Uložiť
				</button>
			</div>
		</div>
	)

	return (
		<Popover
			visible={open}
			onVisibleChange={handleVisibleChange}
			content={content}
			trigger={'click'}
			placement={'bottomLeft'}
			getPopupContainer={(trigger) => (trigger.closest('.ant-modal-body') as HTMLElement) ?? document.body}
			overlayInnerStyle={{ padding: 0 }}
		>
			<span
				style={{
					display: 'inline-flex',
					alignItems: 'center',
					gap: 4,
					padding: '4px 12px',
					border: triggerBorder,
					borderRadius: 20,
					fontSize: 13,
					color: triggerColor,
					cursor: 'pointer',
					background: '#fff',
					userSelect: 'none'
				}}
			>
				{triggerText ?? '+ Penalizácia'}
			</span>
		</Popover>
	)
}

export default PenalizaciaPopover
